import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';
import moment from 'moment';

import { Modal, message, Progress, Popover, Tag } from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function () {

    }
}

const params = {
    domain: {}
};

const headers = utils.columns([
    { key: '$index', label: '序号', width: 75 },
    { key: 'classTime', label: '日期', width: 100, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
    { key: 'lessonNum', label: '节次', width: 60 },
    { key: 'lessonAddress', label: '教室', width: 150 },
    { key: 'weekName', label: '星期', width: 60 },
    { key: 'weekNum', label: '开始周', width: 80, render: value => value ? value.split("~")[0] : "" },
    { key: 'weekNum', label: '结束周', width: 80, render: value => value ? value.split("~")[1] : "" },
    {
        key: 'submitState', label: '选课操作', width: 90,
        render: (value, row, callback) => {
			if (value === '1') return <a href="javascript:;"
			className="sumbit-button"
		><i class="fa fa-check" style={{ color: '#52c41a' }} aria-hidden="true"></i>&nbsp;选课</a> 
		}
            
    },
]);




/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
 const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('course/plan/selection/task/attendLectureList', Object.assign(defaultsParams, keywords))
        .then(response => {
            const columns = [
                { key: '$index', label: '序号', width: 75 },
				{ key: 'classTime', label: '日期', width: 100, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
				{ key: 'lessonNum', label: '节次', width: 60 },
				{ key: 'lessonAddress', label: '教室', width: 150 },
				{ key: 'weekName', label: '星期', width: 60 },
				{ key: 'weekNum', label: '开始周', width: 80, render: value => value ? value.split("~")[0] : "" },
				{ key: 'weekNum', label: '结束周', width: 80, render: value => value ? value.split("~")[1] : "" },
				{
					key: 'allowAttendState', label: '选课操作', width: 90,
					render: (value, row, callback) => {
						if (value === 1) return <a href="javascript:;"
						className="sumbit-button"
					>&nbsp;点击评价</a> 
					}
						
				},
            ];
            return {
                headers: utils.columns(columns),
                data: response.payload.data,
            };
        })
        .then(res => (Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        })));
}


/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection = () => {
    return DataGrid.selections;
}

const getSelectionData = () => {
    return DataGrid.selectData;
}

/**
 * 数据导出
 * @method attendExport
 * @param {object} [keywords]
 * @return {promise}
 */
const attendExport = (keywords) => {
    return fetch.download('course/plan/selection/task/attendExport', keywords, "听课任务信息数据导出.xls")
}



export default {
    querySearch,
    headers,
    onSelect,
    onSelectData,
    setRefresh,
    getSelection,
    getSelectionData,
    params,
    attendExport
}